import { enumFieldDisplayMode } from "../constants";
import { GetFieldLabel } from "./GetFieldLabel";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_DrawText } from "./XML_DrawText";
import { XML_Param5 } from "./XML_Param5";
import { XML_ShiftRect } from "./XML_ShiftRect";

export function XML_DrawCellChartPDF(
  cell,
  r,
  data,
  doLegend,
  fontSize,
  txtFillStyle,
  drawElement,
  theLayer
) {
  cell.GetCellDesc().BuildPieChartContent();
  var s = drawElement.GetStream();
  XML_ShiftRect(r, drawElement, theLayer);
  var temp = r.fTop;
  r.fTop = drawElement.ConvertY(r.fTop);
  r.fBottom = drawElement.ConvertY(r.fBottom);

  var theHeight = Math.abs(r.fTop - r.fBottom);
  var theWidth = Math.abs(r.fRight - r.fLeft);

  var width = cell.GetWidth();
  var radius = width / 2.5 - 4;
  var ratio = radius / width;
  var diameter = 2 * ((r.fRight - r.fLeft) * ratio) - 4;

  var displayMode = cell.GetCellDesc().GetFieldDisplayMode();
  var doLabel = displayMode !== enumFieldDisplayMode.FieldOnly;
  var myField = cell.GetField();
  var fontColor = txtFillStyle;
  var labelFS = cell.GetFontSize();
  var fontFamily = cell.GetFontName();
  if (myField && doLabel) {
    var label = GetFieldLabel(myField);
    XML_DrawText(
      label,
      r.fRight - width / 2,
      temp + (theHeight - diameter) / 4,
      fontColor,
      fontFamily,
      labelFS,
      true,
      false,
      false,
      "left",
      "top",
      false,
      drawElement,
      theLayer
    );
  }

  var dataStr = JSON.stringify(data);
  doLegend = doLegend.toString();
  drawElement.OutputElementHead(s, "chrt");
  XML_AddSingle("pie", "type", drawElement);
  XML_AddSingle(
    JSON.stringify({
      doLegend: doLegend,
      fontSize: fontSize,
      fontColor: fontColor
    }),
    "legend",
    drawElement
  );
  XML_Param5("pos", r.fLeft, r.fBottom, theWidth, theHeight, diameter, drawElement);
  XML_AddSingle(dataStr, "data", drawElement);
  drawElement.OutputElementTail(s, "chrt");
}
